export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11800.ec8c7818.jpg";